import { createSlice } from "@reduxjs/toolkit";

export const error = createSlice({
  name: "error",
  initialState: {
    status: null,
    message: null,
  },
  reducers: {
    setError: (state, action) => {
      return { ...state, ...action.payload };
    },
  },
});

export const { setError } = error.actions;

export default error.reducer;
